import React from "react";
import { Navigate } from "react-router-dom";
import { useEventsFeature } from "@/contexts/EventsFeatureContext";

const GateFallback: React.FC = () => (
  <div
    style={{
      minHeight: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  />
);

/** Blocks `/forecast` routes when the Vercel `forecast` flag is off. */
export const PublicForecastRouteGate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { ready, forecastEnabled } = useEventsFeature();
  if (!ready) {
    return <GateFallback />;
  }
  if (!forecastEnabled) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};
